export default function IdleState() {
  return (
    <div className="ai-state-container">
      {/* Pulsing ready indicator */}
      <div className="ai-idle-ready-indicator">
        <div className="ai-ready-dot"></div>
      </div>

      {/* Clear status */}
      <div className="ai-status-text">
        <span className="ai-idle-text">Esperando</span>
      </div>
    </div>
  );
}
